import {
    throwErrorMessage,
    throwSuccessMessage,
    throwErrorWithGenericExternalBusinessError,
} from "../../lib/error_helper";
import { redirect, absencesIsLoading, setEditionState, setAbsenceCreationFields } from "./absencesActions";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import moment from "moment";
import { GET_REFUSE_REASONS } from "./absencesConstants";

export function getAbsencesRefuseReasonsAction(reasons) {
    return {
        type: GET_REFUSE_REASONS,
        reasons: reasons,
    };
}

function checkDetailsIntegrity(details) {
    let prefix = "";

    if (details.filter((d) => d.morning || d.afternoon).length <= 0) throw new Error("Aucun détail n'a été renseigné");

    details.forEach((d) => {
        prefix = "Une anomalie a été trouvée pour le détail numéro " + d.id + ": ";

        if (!d.date || d.date === null || !moment(d.date).isValid()) throw new Error(prefix + "La date est invalide");

        if (d.morning && !d.morning_type_id) throw new Error(prefix + "Le type d'absence du matin est invalide");

        if (d.afternoon && !d.afternoon_type_id)
            throw new Error(prefix + "Le type d'absence de l'après midi est invalide");
    });

    return;
}

function redirectToAbsencesPage() {
    return (dispatch) => {
        dispatch(redirect("/absences"));
    };
}

function castAbsenceToServerFormat(absencesState) {
    let date_to = moment(absencesState.absenceCreationFields.date_to).toDate();
    date_to = date_to.setHours(date_to.getHours() - date_to.getTimezoneOffset() / 60);
    date_to = moment(date_to);

    let date_from = moment(absencesState.absenceCreationFields.date_from).toDate();
    date_from = date_from.setHours(date_from.getHours() - date_from.getTimezoneOffset() / 60);
    date_from = moment(date_from);

    let absence = {
        emp_id: absencesState.absenceCreationFields.employeeId,
        type: "normal",
        state: absencesState.absenceCreationFields.status,
        date_to: JSON.stringify(date_to),
        date_from: JSON.stringify(date_from),
        default_absence_type_id: absencesState.absenceCreationFields.defaultAbsenceTypeId,
        comment: absencesState.absenceCreationFields.comment,
        date_ids: JSON.stringify(
            absencesState.absenceDetails.map(function (d) {
                delete d["id"];
                let date = moment(d.date).toDate();
                date = date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
                d.date = moment(date);
                return d;
            })
        ),
    };

    if (absencesState.absenceCreationFields.id) {
        absence.id = absencesState.absenceCreationFields.id;
    }

    return absence;
}

export function submitOrEditAbsence(absencesState, activeUser) {
    return (dispatch) => {
        try {
            checkDetailsIntegrity(absencesState.absenceDetails);

            if (!absencesState.absenceCreationFields.id) {
                dispatch(submit(absencesState, activeUser));
            } else {
                dispatch(updateAndConfirm(absencesState, activeUser));
            }
        } catch (err) {
            console.error("Erreur : absencesEditionActions - submitOrEditAbsence " + err.message);
            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la soumission de l'absence: " + err.message,
                })
            );
        }
    };
}

export function submit(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/submitAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence soumise avec succès !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - submit: " + err.message);
                dispatch(throwErrorWithGenericExternalBusinessError(err, "Erreur lors de la soumission de l'absence!"));
                dispatch(absencesIsLoading(false));
            });
    };
}

export function submitOrEditAsDraft(absencesState, activeUser) {
    return (dispatch) => {
        try {
            checkDetailsIntegrity(absencesState.absenceDetails);

            if (!absencesState.absenceCreationFields.id) {
                dispatch(submitAsDraft(absencesState, activeUser));
            } else {
                dispatch(update(absencesState, activeUser));
            }
        } catch (err) {
            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la sauvegarde en brouillon de l'absence: " + err.message,
                })
            );
        }
    };
}

export function submitAsDraft(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/submitAbsenceAsDraftRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence enregistrée en tant que brouillon !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - submitAsDraft: " + err.message);
                dispatch(
                    throwErrorWithGenericExternalBusinessError(
                        err,
                        "Erreur lors de la sauvegarde de l'absence en brouillon !"
                    )
                );
                dispatch(absencesIsLoading(false));
            });
    };
}

export function updateAndConfirm(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/updateAndConfirmAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence soumise avec succès !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - updateAndConfirm: " + err.message);
                dispatch(
                    throwErrorWithGenericExternalBusinessError(
                        err,
                        "Erreur lors de la soumission d'une absence existante !"
                    )
                );
                dispatch(absencesIsLoading(false));
            });
    };
}

export function update(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/updateAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Brouillon modifié avec succès !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - update: " + err.message);
                dispatch(
                    throwErrorWithGenericExternalBusinessError(err, "Erreur lors de la modification d'un brouillon !")
                );
                dispatch(absencesIsLoading(false));
            });
    };
}

export function cancel(absencesState, activeUser) {
    return (dispatch) => {
        if (!window.confirm("Êtes-vous sûr(e) de vouloir annuler votre demande?")) {
            return;
        }

        if (absencesState.absenceCreationFields.id) {
            dispatch(cancelRequest(absencesState, activeUser));
        } else {
            dispatch(redirectToAbsencesPage());
        }
    };
}

export function cancelRequest(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });

        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/cancelAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    if (response.status !== 550) {
                        throw Error(response.statusText);
                    }
                }
                return response;
            })
            .then((response) => response.json())
            .then((retour) => {
                if (retour.message && retour.type) {
                    //Type d'exception particulier pour erreur venant d'OpenErp
                    dispatch(
                        throwErrorMessage({
                            errorObject: retour,
                            title: "Erreur",
                            message: retour.message,
                        })
                    );

                    return;
                }

                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence annulée avec succès !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - cancel: " + err.message);
                dispatch(throwErrorWithGenericExternalBusinessError(err, "Erreur lors de l'annulation de l'absence !"));
                dispatch(absencesIsLoading(false));
            });
    };
}

export function reEdit(absencesState, activeUser) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/reEdit/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence remise en brouillon !",
                    })
                );

                dispatch(setEditionState(false, true, false));
                dispatch(
                    setAbsenceCreationFields(
                        absencesState.absenceCreationFields.id,
                        absencesState.absenceCreationFields.employeeId,
                        absencesState.absenceCreationFields.defaultAbsenceTypeId,
                        absencesState.absenceDetails,
                        "new",
                        absencesState.absenceCreationFields.counters,
                        absencesState.absenceCreationFields.date_from,
                        absencesState.absenceCreationFields.date_to,
                        absencesState.absenceCreationFields.comment,
                        activeUser.id
                    )
                );
                dispatch(redirect("/absences/editAbsence"));
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - reEdit: " + err.message);
                dispatch(
                    throwErrorWithGenericExternalBusinessError(
                        err,
                        "Erreur lors de la remise en brouillon de l'absence !"
                    )
                );
                dispatch(absencesIsLoading(false));
            });
    };
}

export function validate(absencesState, activeUser) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        if (absencesState.absenceCreationFields.employeeId === activeUser.emp_id) {
            dispatch(
                throwErrorMessage({
                    title: "Erreur",
                    message: "Le validateur d'une absence doit être différent de son créateur !",
                })
            );

            return;
        }

        dispatch(absencesIsLoading(true));
        const body = JSON.stringify({
            absence: castAbsenceToServerFormat(absencesState),
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/validateAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence validée !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - validate: " + err.message);
                dispatch(
                    throwErrorWithGenericExternalBusinessError(err, "Erreur lors de la validation de l'absence !")
                );
                dispatch(absencesIsLoading(false));
            });
    };
}

export function refuse(absencesState, activeUser, reasonId, comment) {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });

        const body = JSON.stringify({
            absenceReason: {
                reasonId,
                comment,
            },
            absenceId: absencesState.absenceCreationFields.id,
            userId: activeUser.id,
        });

        fetchWithTimeout("/api/v1/absences/refuseAbsenceRequest/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Absence refusée !",
                    })
                );
                dispatch(redirectToAbsencesPage());
            })
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - refuse: " + err.message);
                dispatch(throwErrorWithGenericExternalBusinessError(err, "Erreur lors du refus de l'absence !"));
                dispatch(absencesIsLoading(false));
            });
    };
}

export function getRefuseReasons() {
    return (dispatch) => {
        dispatch(absencesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/absences/get_refuse_reasons", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(absencesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((reasons) => dispatch(getAbsencesRefuseReasonsAction(reasons)))
            .catch((err) => {
                console.error("Erreur : absencesEditionActions - getRefuseReasons");
                dispatch(
                    throwErrorWithGenericExternalBusinessError(
                        err,
                        "Erreur lors de la récupération des motifs de refus !"
                    )
                );
                dispatch(absencesIsLoading(false));
            });
    };
}
